import { render, staticRenderFns } from "./RTapBenefits.vue?vue&type=template&id=6db5b210&scoped=true&"
var script = {}
import style0 from "./RTapBenefits.vue?vue&type=style&index=0&id=6db5b210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db5b210",
  null
  
)

export default component.exports